import { Component, OnInit, Inject} from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import swal from 'sweetalert2';

import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { FechamentoFinanceiroService } from '../../services/fechamento-financeiro.service';

@Component({
  selector: 'app-selecionar-status-fechamento',
  templateUrl: './selecionar-status-fechamento.component.html',
  styleUrls: ['./selecionar-status-fechamento.component.scss']
})
export class SelecionarStatusFechamentoComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  idFechamento: number;
  valorFechamento: number;
  idStatus: number;
  descricaoStatus: string;
  enumStatus = [
    { id: 0, name: 'Em análise' },
    { id: 1, name: 'Aprovado' },
    { id: 2, name: 'Reprovado' },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private fechamentoFinanceiroService: FechamentoFinanceiroService,
    public dialogRef: MatDialogRef<SelecionarStatusFechamentoComponent>,
    private currencyPipe: CurrencyPipe,
  ) {
    this.idFechamento = data.idFechamento;
    this.idStatus = data.idStatus;
    this.valorFechamento = data.valorFechamento;
  }

  ngOnInit(): void {
  }

  selecionaStatus(idStatus: number) {
    swal({
      title: 'Atenção!!',
      html: `Deseja realmente alterar o status do fechamento <br/>
             Nº <strong class="font-weight-bold">${('0000000' + this.idFechamento).slice(-7)}</strong>
             no Valor de <strong class="font-weight-bold">${this.currencyPipe.transform(this.valorFechamento, 'BRL')}</strong>
             para <strong class="font-weight-bold">${this.enumStatus.find(p => p.id === idStatus).name}</strong>? `,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('buscarStatusFechamento');

        this.fechamentoFinanceiroService.alterarStatusDoFechamento(this.idFechamento, idStatus).subscribe((data: any) => {
          this.dialogRef.close(idStatus);
          this.carregandoService.esconde('buscarStatusFechamento');
        }, (erro) => {
          this.carregandoService.esconde('buscarStatusFechamento');
          this.notificacaoService.erro(erro);
        });
      }

      this.dialogRef.close();
    });
  }
}
